import { ReactElement, useMemo } from 'react';
import { TableColumns, TableRows } from '@app/common/DataTable/types';
import Lang from '@lang/en';
import Loader from '@app/common/loadData/Loader';
import OrdersTable from '.';
import useOrdersData from '../useOrdersData';
import { NullableNumber } from '@app/common/types';
import { ArrowRightGreen, UserIcon } from '@root/src/assets/images';
import { ClickableIcon } from '../styles';
import {
  dateTime24FriendlyFormatWithComma,
  formatUTCStringAsApiTimestamp,
} from '@app/utils';
import { GenericOrderTable } from '..';
import { getTestTypeLabel } from '../utils';

export const columns: TableColumns = [
  {
    key: 'icon',
    title: '',
    'data-testid': 'healthCheck-ordersTable-icon',
  },
  {
    key: 'name',
    title: Lang.nameLabel,
    sort: false,
    sortKey: 'name',
    'data-testid': 'healthCheck-ordersTable-name',
  },
  {
    key: 'testType',
    title: Lang.healthCheckTestTypeLabel,
    sortKey: 'testType',
    'data-testid': 'healthCheck-ordersTable-testType',
  },
  {
    key: 'bookedDate',
    title: Lang.healthCheckBookedDateLabel,
    sortKey: 'bookedDate',
    'data-testid': 'healthCheck-ordersTable-bookedDate',
  },
  {
    key: 'showDetails',
    title: '',
    widthOverride: '40px',
    'data-testid': 'healthCheck-ordersTable-showDetails',
  },
];

const ConfirmedTable = ({ onOrderClick }: GenericOrderTable): ReactElement => {
  const { ordersList, loading } = useOrdersData();

  const tableRows = useMemo(() => {
    return ordersList.map((row) => {
      const dateTime = formatUTCStringAsApiTimestamp(
        row.bookedDate,
        dateTime24FriendlyFormatWithComma
      );
      return {
        id: {
          value: row.id,
        },
        icon: {
          value: <UserIcon />,
        },
        name: { value: `${row.firstName} ${row.lastName}` },
        bookedDate: { value: dateTime },
        testType: {
          value: getTestTypeLabel(row.testType, row.testCategory),
        },
        showDetails: {
          value: (
            <ClickableIcon
              onClick={() =>
                onOrderClick((row.id as unknown) as NullableNumber)
              }
            >
              <ArrowRightGreen />
            </ClickableIcon>
          ),
        },
      };
    });
  }, [onOrderClick, ordersList]);

  return loading ? (
    <Loader />
  ) : (
    <OrdersTable
      onOrderClick={onOrderClick}
      rows={(ordersList as unknown) as TableRows}
      tableRows={tableRows}
      columns={columns}
    />
  );
};

export default ConfirmedTable;
